export const monitoringTour = {
    module: 'monitoring',
    title: 'Monitoring Tour',
    title_vi: 'Tour Giám sát',
    description: 'As the Enterprise DPO (P-VN-01), establish ongoing compliance monitoring programs, track regulatory changes, measure KPIs, and manage regulatory interaction cases under PDPL.',
    description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Enterprise DPO (P-VN-01), establish ongoing compliance monitoring programs, track regulatory changes, measure KPIs, and manage regulatory interaction cases under PDPL.',
    estimated_duration_seconds: 48,
    steps: [
        {
            step_id: 'open_monitoring',
            navigate_to: '/admin/monitoring/programs',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Monitoring Programs',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Monitoring Programs',
            description: 'As the DPO, you define ongoing compliance monitoring programs here. PDPL requires continuous oversight of processing activities, and these programs structure your review cycles, evidence collection, and KPI tracking.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the DPO, you define ongoing compliance monitoring programs here. PDPL requires continuous oversight of processing activities, and these programs structure your review cycles, evidence collection, and KPI tracking.',
            position: 'bottom',
        },
        {
            step_id: 'create_program',
            target: '.dm-header .btn-primary',
            title: 'Create a New Program',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Create a New Program',
            description: 'Define a new monitoring program linked to specific PDPL compliance frameworks and review frequencies.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Define a new monitoring program linked to specific PDPL compliance frameworks and review frequencies.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 300,
        },
        {
            step_id: 'program_form',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Program Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Program Form',
            description: 'Define the program scope, review frequency, and linked PDPL frameworks. Regular quarterly reviews align with Vietnamese regulatory reporting cycles.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Define the program scope, review frequency, and linked PDPL frameworks. Regular quarterly reviews align with Vietnamese regulatory reporting cycles.',
            position: 'right',
        },
        {
            step_id: 'review_periods',
            navigate_to: '/admin/monitoring/periods',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Review Periods',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Review Periods',
            description: 'Each program operates through time-boxed review periods that track task completion, evidence collection, and compliance posture. Completed periods produce audit-grade review dossiers for PDP Committee inspections.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Each program operates through time-boxed review periods that track task completion, evidence collection, and compliance posture. Completed periods produce audit-grade review dossiers for PDP Committee inspections.',
            position: 'bottom',
        },
        {
            step_id: 'create_period',
            target: '.dm-header > div button:nth-child(2)',
            title: 'Create a Review Period',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Create a Review Period',
            description: 'Define a review window for a monitoring program. Align periods with your PDPL reporting obligations and internal audit calendar.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Define a review window for a monitoring program. Align periods with your PDPL reporting obligations and internal audit calendar.',
            position: 'bottom',
        },
        {
            step_id: 'tasks_page',
            navigate_to: '/admin/monitoring/tasks',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Monitoring Tasks',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Monitoring Tasks',
            description: 'Individual compliance checks and evidence-gathering activities assigned to team members within each review period. Completed tasks build the evidence base proving ongoing PDPL compliance.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Individual compliance checks and evidence-gathering activities assigned to team members within each review period. Completed tasks build the evidence base proving ongoing PDPL compliance.',
            position: 'bottom',
        },
        {
            step_id: 'create_task',
            target: '.dm-header > div button:nth-child(2)',
            title: 'Create a Task',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Create a Task',
            description: 'Assign a compliance check to a team member with a deadline. Each completed task contributes to the review period evidence package and KPI measurements.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Assign a compliance check to a team member with a deadline. Each completed task contributes to the review period evidence package and KPI measurements.',
            position: 'bottom',
        },
        {
            step_id: 'task_templates',
            navigate_to: '/admin/monitoring/task-templates',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Task Templates',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Task Templates',
            description: 'Reusable task definitions that standardize PDPL monitoring activities across programs. Templates ensure consistent compliance checks regardless of which team member executes them.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Reusable task definitions that standardize PDPL monitoring activities across programs. Templates ensure consistent compliance checks regardless of which team member executes them.',
            position: 'bottom',
        },
        {
            step_id: 'create_template',
            target: '.dm-header > div button:nth-child(2)',
            title: 'Create a Task Template',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Create a Task Template',
            description: 'Define a reusable template for common monitoring activities such as ROPA reviews, consent audit checks, or vendor compliance verifications.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Define a reusable template for common monitoring activities such as ROPA reviews, consent audit checks, or vendor compliance verifications.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header > div button:nth-child(2)' },
            duration_ms: 100,
        },
        {
            step_id: 'template_form',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Task Template Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Task Template Form',
            description: 'Define the template name, description, category, and standard instructions. Well-structured templates produce consistent, auditable monitoring evidence across review cycles.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Define the template name, description, category, and standard instructions. Well-structured templates produce consistent, auditable monitoring evidence across review cycles.',
            position: 'right',
        },
        {
            step_id: 'kpi_dashboard',
            navigate_to: '/admin/monitoring/kpi',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'KPI Dashboard',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: KPI Dashboard',
            description: 'Aggregate compliance performance metrics across all monitoring programs. As the DPO, use KPI trends to identify declining compliance areas and report posture improvements to leadership and the PDP Committee.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Aggregate compliance performance metrics across all monitoring programs. As the DPO, use KPI trends to identify declining compliance areas and report posture improvements to leadership and the PDP Committee.',
            position: 'bottom',
        },
        {
            step_id: 'kpi_snapshot',
            target: '.dm-header button',
            title: 'Capture a KPI Snapshot',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Capture a KPI Snapshot',
            description: 'Record a point-in-time snapshot of compliance KPIs. Snapshots build historical trend data demonstrating continuous PDPL compliance improvement for board and regulatory reporting.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Record a point-in-time snapshot of compliance KPIs. Snapshots build historical trend data demonstrating continuous PDPL compliance improvement for board and regulatory reporting.',
            position: 'bottom',
        },
        {
            step_id: 'ric_cases',
            navigate_to: '/admin/monitoring/ric',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'RIC Cases (Regulatory Interactions & Correspondence)',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: RIC Cases (Regulatory Interactions & Correspondence)',
            description: 'As the DPO, you track all formal interactions with the PDP Committee and other regulators here: inquiries, inspections, enforcement actions, and correspondence with evidence attachments and response deadlines.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the DPO, you track all formal interactions with the PDP Committee and other regulators here: inquiries, inspections, enforcement actions, and correspondence with evidence attachments and response deadlines.',
            position: 'bottom',
        },
        {
            step_id: 'create_ric',
            target: '.dm-header button',
            title: 'Create a RIC Case',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Create a RIC Case',
            description: 'Register a new regulatory interaction from the PDP Committee or other authority. Timely response tracking prevents escalation to enforcement actions.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Register a new regulatory interaction from the PDP Committee or other authority. Timely response tracking prevents escalation to enforcement actions.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header button' },
            duration_ms: 300,
        },
        {
            step_id: 'ric_template_picker',
            target: '.dm-modal .template-picker',
            wait_for: '.template-picker',
            title: 'Choose a RIC Template',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Choose a RIC Template',
            description: 'Select a pre-built template for common regulatory interaction types (inquiry, inspection, enforcement), or start from a blank case.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Select a pre-built template for common regulatory interaction types (inquiry, inspection, enforcement), or start from a blank case.',
            position: 'bottom',
            delay_ms: 500,
        },
        {
            step_id: 'ric_select_template',
            target: '.template-picker-blank',
            title: 'Start from Blank',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Start from Blank',
            description: 'Select the blank template to document the regulatory interaction from scratch.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Select the blank template to document the regulatory interaction from scratch.',
            position: 'bottom',
            action: { type: 'click', target: '.template-picker-blank' },
            delay_ms: 300,
        },
        {
            step_id: 'ric_form',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'RIC Case Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: RIC Case Form',
            description: 'Document the regulatory interaction with reference number, regulator name, response deadline, and case type. This produces an audit-grade correspondence dossier with evidence attachments and follow-up lineage.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Document the regulatory interaction with reference number, regulator name, response deadline, and case type. This produces an audit-grade correspondence dossier with evidence attachments and follow-up lineage.',
            position: 'right',
            action: { type: 'click', target: '.dm-form-actions button[type="button"]' },
            duration_ms: 300,
        },
        {
            step_id: 'mon_complete',
            target: '.dm-page',
            title: 'Monitoring Tour Complete',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Monitoring Tour Complete',
            description: 'You can now establish ongoing PDPL compliance monitoring: structured review programs, KPI tracking, task templates, and regulatory interaction case management with audit-grade evidence packages.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: You can now establish ongoing PDPL compliance monitoring: structured review programs, KPI tracking, task templates, and regulatory interaction case management with audit-grade evidence packages.',
            position: 'bottom',
        },
    ],
};
//# sourceMappingURL=monitoring.js.map